module.exports = __webpack_public_path__ + "static/media/sortingup-theme.ed3d5be0.svg";